import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';

interface CustomInputLabelProps {
    fontSize?: string | number;
    fontWeight?: React.CSSProperties['fontWeight'] | 'none';
}

/** Matches ReservationEditDetailsSection `labelSx` (body3, 800, secondary). */
const CustomInputLabel = styled(InputLabel, {
    shouldForwardProp: (prop) => prop !== 'fontSize' && prop !== 'fontWeight',
})<CustomInputLabelProps>(({ theme, fontSize, fontWeight }) => {
    const isSubLabel =
        fontWeight === 'none' || fontWeight === 400 || fontWeight === 'normal';

    const resolvedWeight = isSubLabel
        ? (theme.typography.fontWeightRegular ?? 400)
        : fontWeight != null && fontWeight !== 'none'
          ? fontWeight
          : 800;

    const mainFontSize = fontSize ?? theme.typography.body3.fontSize;

    return {
        ...theme.typography.body3,
        marginBottom: theme.spacing(0.5),
        display: 'block',
        fontSize: mainFontSize,
        fontWeight: resolvedWeight,
        lineHeight: 1.35,
        color: theme.palette.text.secondary,
        whiteSpace: 'normal',
        '&&:not(.MuiInputLabel-shrink)': {
            transform: 'none',
            position: 'static',
            color: theme.palette.text.secondary,
            fontSize: mainFontSize,
            fontWeight: resolvedWeight,
            lineHeight: 1.35,
        },
    };
});

export default CustomInputLabel;
